<div class="client-table">
  <form class="filters-row">
    <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
      <input
        matInput
        [(ngModel)]="searchTerm"
        (input)="applyFilter($event)"
        autocomplete="off"
        [placeholder]="'client.searchPlaceholder' | translate"
        [attr.aria-label]="'client.search' | translate"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </form>

  <div
    class="table-container"
    [class.table-container--empty]="isEmpty || showNoSearchResults"
    [class.table-container--loading]="loading"
  >
    <div class="accordion-container" *ngIf="!isEmpty && !showNoSearchResults">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let planGroup of planGroups; trackBy: trackByPlanId"
          [expanded]="isPlanExpanded(planGroup.planId)"
          (opened)="setPlanExpanded(planGroup.planId, true)"
          (closed)="setPlanExpanded(planGroup.planId, false)"
          class="plan-panel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="plan-header">
                <mat-icon class="plan-icon">{{
                  getPlanIcon(planGroup.planId)
                }}</mat-icon>
                <span class="plan-name">{{ planGroup.displayName }}</span>
                <span class="plan-count">({{ planGroup.filteredCount }})</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="table-wrapper">
            <mat-table
              [dataSource]="planGroup.dataSource"
              class="clients-table mat-elevation-z0"
            >
              <ng-container matColumnDef="expand">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    type="button"
                    (click)="toggleExpand(element.domain); $event.stopPropagation()"
                    *ngIf="shouldShowExpandIcon(element)"
                    [matTooltip]="
                      isExpanded(element.domain) ? 'Collapse' : 'Expand'
                    "
                  >
                    <mat-icon>{{
                      isExpanded(element.domain)
                        ? "expand_less"
                        : "expand_more"
                    }}</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    *ngIf="isSubdomain(element)"
                    class="subdomain-indicator"
                    disabled
                  >
                    <mat-icon>remove</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.name" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div
                    class="name-wrapper"
                    (click)="
                      goToClient(element.domain); $event.stopPropagation()
                    "
                    [matTooltip]="'client.goToClient' | translate"
                  >
                    <mat-icon>open_in_browser</mat-icon>
                    <img
                      [src]="element.photoUrl || '/assets/img/favicon.png'"
                      class="client-image"
                      alt=""
                    />
                    <div class="name-cell">
                      <span>{{ element.name || "-" }}</span>
                      <code>{{ element.domain }}</code>
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="googleAdminEmail">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.googleAdminEmail" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <code>{{ element.googleAdminEmail }}</code>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.createdAt" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element" [title]="element.createdAt">
                  <span [matTooltip]="element.createdAt">{{
                    element.createdAt | localizedDate
                  }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="stats">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.stats" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div class="stats-container">
                    <span class="chip">
                      {{
                        element.stats.current
                          .numberOfEmployeesWithSignatureInstalled
                      }}
                      /
                      {{ element.stats.current.numberOfEmployees }}
                    </span>
                    <span class="previous-stats">
                      ({{
                        element.stats.previous
                          .numberOfEmployeesWithSignatureInstalled
                      }}
                      /
                      {{ element.stats.previous.numberOfEmployees }})
                    </span>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="planId">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.subscription" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element" [title]="element.planId">
                  <span [matTooltip]="element.planId">{{
                    element.planId
                  }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="trialFinishDate">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.trialFinishDate" | translate
                }}</mat-header-cell>
                <mat-cell
                  *matCellDef="let element"
                  [title]="element.trialFinishDate"
                >
                  <span [matTooltip]="element.trialFinishDate">{{
                    element.trialFinishDate | localizedDate
                  }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="billingType">
                <mat-header-cell *matHeaderCellDef>{{
                  "client.billingType.label" | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{
                    ("client.billingType." + (element.billingMode || "default"))
                      | translate
                  }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="addSubdomain">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    type="button"
                    (click)="addSubdomain(element); $event.stopPropagation()"
                    [matTooltip]="'client.addSubdomainTooltip' | translate"
                    class="add-subdomain-button"
                    *ngIf="!element.parentDomain"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions" *ngIf="actionsTemplate">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <ng-content
                    *ngTemplateOutlet="
                      actionsTemplate;
                      context: { client: element }
                    "
                  ></ng-content>
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="table-row--clickable"
                [class.subdomain]="row.parentDomain"
                [attr.data-domain]="row.domain"
                [appTableRowLink]="clientDetailLink(row)"
              ></mat-row>
            </mat-table>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="loading-wrapper" *ngIf="loading">
      <app-loading></app-loading>
    </div>

    <div class="empty-state" *ngIf="!loading && isEmpty">
      <mat-icon class="empty-state__icon">business</mat-icon>
      <p>{{ "client.addNew" | translate }}</p>
    </div>

    <div class="empty-state" *ngIf="showNoSearchResults">
      <mat-icon class="empty-state__icon">search_off</mat-icon>
      <p>{{ "client.search" | translate }}</p>
    </div>
  </div>
</div>
